export default __webpack_public_path__ + "static/media/organizeSmall.ee218565.png";